import styled from 'styled-components';
import colors from 'styles/colors';

export const Radio = styled.div`
  width: 13px;
  height: 13px;
  border: 1px solid ${colors.primary};
  cursor: pointer;
  position: relative;
  border-radius: 1px;
`;

export const SelectedRadio = styled(Radio)`
  width: 7px;
  height: 7px;
  border: 0;
  margin: 3px;
  background-color: ${colors.highlight};

  &:after {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border: 1px solid ${colors.highlight};
  }
`;

export const RadioRound = styled.div<{ selected: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-right: 20px;
  background-color: ${(props) => (props.selected ? colors.blue : colors.gray75)};
  transition: background-color 0.25s;

  & > div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    transform: ${(props) => (props.selected ? 'scale(0.3, 0.3)' : 'scale(0.8, 0.8)')};
    background-color: ${colors.white};
    transition: transform 0.5s;
  }
`;

export const SelectedRadioRound = styled(RadioRound)`
  cursor: auto;
  background-color: ${colors.blue};
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-transform: uppercase;

  ${RadioRound} {
    margin-right: 7px;
  }

  & + & {
    margin-left: 2em;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  margin-bottom: 1em;
`;

export const RadioItem = styled.div`
  display: flex;
  align-items: center;
`;
